/* VB ajustes Oct-19 */
(function () {
  var SEP = '<span aria-hidden="true">&nbsp; • &nbsp;</span>';

  /* 8 - breadcrumb con categoria: Inicio > Loncheras > Producto */
  function breadcrumb() {
    var c = window.vbCol;
    if (!c) return;
    document.querySelectorAll('nav.breadcrumb').forEach(function (nav) {
      if (nav.dataset.vbCol) return;
      var links = nav.querySelectorAll('a');
      if (links.length !== 1) { nav.dataset.vbCol = '1'; return; }
      var a = document.createElement('a');
      a.href = c.u; a.textContent = c.t;
      links[0].nextElementSibling.insertAdjacentElement('afterend', a);
      a.insertAdjacentHTML('afterend', SEP);
      nav.dataset.vbCol = '1';
    });
  }

  /* 20 - "Colecciones" -> "Categorías" */
  function categorias() {
    document.querySelectorAll('nav.breadcrumb a[href="/collections"]').forEach(function (a) {
      if (/colecciones|collections/i.test(a.textContent)) a.textContent = 'Categorías';
    });
    if (location.pathname.replace(/\/$/, '') === '/collections') {
      var m = document.querySelector('main .collection-list');
      if (m) { var s = m.closest('.shopify-section'); if (s) s.classList.add('vb-cats'); }
      if (/^Colecciones/i.test(document.title)) document.title = document.title.replace(/^Colecciones/i, 'Categorías');
    }
  }

  /* 15/18 - seguir comprando -> VER TODO */
  function verTodo() {
    document.querySelectorAll('a[href="/collections/all"]').forEach(function (a) {
      if (!/seguir comprando|continuar comprando|continue shopping/i.test(a.textContent)) return;
      a.setAttribute('href', '/collections/ver-todo');
      var sp = a.querySelector('span');
      if (sp) sp.textContent = 'VER TODO'; else a.textContent = 'VER TODO';
      if (a.classList.contains('button')) a.classList.add('vb-vertodo');
    });
  }

  /* 11 - titulo de la busqueda en espanol */
  function buscar() {
    document.querySelectorAll('.search-modal___header h2').forEach(function (h) {
      if (/^\s*search\s*$/i.test(h.textContent)) h.textContent = 'Buscar';
    });
  }

  /* 1 - boton para volver a la primera foto */
  function firstPhoto() {
    var list = document.querySelector('.product__media-wrapper .product__media-list');
    if (!list || list.dataset.vbFirst) return;
    list.dataset.vbFirst = '1';
    var holder = list.closest('slider-component') || list.parentElement;
    if (getComputedStyle(holder).position === 'static') holder.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vb-first';
    b.setAttribute('aria-label', 'Volver a la primera foto');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 5v14"/><path d="M18 6l-7 6 7 6"/></svg>';
    holder.appendChild(b);
    function upd() { b.classList.toggle('is-on', list.scrollLeft > 30); }
    list.addEventListener('scroll', upd, { passive: true });
    b.addEventListener('click', function () { list.scrollTo({ left: 0, behavior: 'smooth' }); });
    upd();
  }

  /* Bs sin simbolo de equivalente */
  function bs() {
    document.querySelectorAll('p.vb-bs').forEach(function (p) {
      var t = p.firstChild;
      if (t && t.nodeType === 3 && t.nodeValue.indexOf('≈') > -1) t.nodeValue = t.nodeValue.replace('≈', '').replace(/^\s+/, '');
    });
    document.querySelectorAll('.vb-bs-cart').forEach(function (p) {
      var v = p.textContent.replace(/^\s*≈\s*/, '');
      if (p.getAttribute('data-t') !== v) p.setAttribute('data-t', v);
    });
  }

  /* tambien podria gustarte: tarjetas mas pequenas en movil */
  function recos() {
    var el = document.querySelector('.related-products .swiper-initialized');
    if (!el || !el.swiper || el.dataset.vbSm) return;
    el.dataset.vbSm = '1';
    var sw = el.swiper, bp = sw.params.breakpoints || {};
    if (bp['318']) { bp['318'].slidesPerView = 1.8; bp['318'].spaceBetween = 10; }
    if (window.innerWidth < 500) { sw.params.slidesPerView = 1.8; sw.params.spaceBetween = 10; }
    if (bp['1024']) bp['1024'].slidesPerView = 5;
    if (window.innerWidth >= 1024) sw.params.slidesPerView = 5;
    sw.update();
  }

  /* envio gratis junto al boton de agregar */
  function trust() {
    var sub = document.querySelector('.product__info-container .product-form__submit');
    if (!sub || document.querySelector('.vb-trust')) return;
    var blk = sub;
    while (blk.parentElement && !blk.parentElement.classList.contains('product__info-container')) blk = blk.parentElement;
    if (!blk.parentElement) return;
    var d = document.createElement('div');
    d.className = 'vb-trust';
    d.innerHTML = '<p><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg><span><b>Delivery en Caracas y Envío Nacional Gratuitos</b> para pedidos desde Ref 35</span></p>';
    blk.insertAdjacentElement('afterend', d);
  }

  /* boton de agregar fijo abajo en movil */
  function stickyBar() {
    var sub = document.querySelector('.product__info-container .product-form__submit');
    if (!sub || document.querySelector('.vb-sb')) return;
    var title = document.querySelector('.product__info-container .product__title');
    var bar = document.createElement('div');
    bar.className = 'vb-sb';
    bar.innerHTML = '<div class="vb-sb__info"><p class="vb-sb__t"></p><p class="vb-sb__p"></p></div><button type="button" class="vb-sb__b">Agregar al carrito</button>';
    document.body.appendChild(bar);
    bar.querySelector('.vb-sb__t').textContent = title ? title.textContent.trim() : '';
    var btn = bar.querySelector('.vb-sb__b');
    btn.addEventListener('click', function () { sub.click(); });
    function price() {
      var p = document.querySelector('.product__info-container .price .price-item--sale.price-item--last, .product__info-container .price__regular .price-item--regular');
      var on = document.querySelector('.product__info-container .price--on-sale');
      if (on) p = on.querySelector('.price__sale .price-item--sale') || p;
      return p ? p.textContent.replace(/\s+/g, ' ').trim() : '';
    }
    function upd() {
      var r = sub.getBoundingClientRect();
      var show = r.bottom < 0 && window.innerWidth < 750;
      bar.classList.toggle('is-on', show);
      document.body.classList.toggle('vb-sb-on', show);
      var pt = price();
      var pe = bar.querySelector('.vb-sb__p');
      if (pe.textContent !== pt) pe.textContent = pt;
      btn.disabled = sub.disabled;
      var bt = sub.disabled ? 'Agotado' : 'Agregar al carrito';
      if (btn.textContent !== bt) btn.textContent = bt;
    }
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* 4 - altura del header para el sticky de la info del producto */
  function headerVar() {
    var h = document.querySelector('.header-wrapper');
    if (h) document.documentElement.style.setProperty('--vb-hh', h.offsetHeight + 'px');
  }

  /* 3 - descripcion debajo de compartelo en desktop */
  function moveDesc() {
    if (window.innerWidth < 750) return;
    var tabs = document.querySelector('.text_tabs-section');
    var info = document.querySelector('.product__info-container');
    if (!tabs || !info || info.contains(tabs)) return;
    var sec = tabs.closest('.shopify-section');
    var after = info.querySelector('.social-sharing') || info.lastElementChild;
    var blk = after;
    while (blk.parentElement && blk.parentElement !== info) blk = blk.parentElement;
    blk.insertAdjacentElement('afterend', tabs);
    if (sec) sec.classList.add('vb-desc-moved');
  }

  /* 6 - compartir por WhatsApp, Pinterest e Instagram */
  var IC = {
    wa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 20.5l1.3-4A8.5 8.5 0 1 1 8 19.3l-4.5 1.2z"/><path d="M9.2 8.6c-.6 0-1.2.6-1.1 1.4.3 2.6 3.2 5.4 5.8 5.8.8.1 1.4-.5 1.4-1.1v-.6l-1.9-.8-.8.9c-1.2-.5-2.3-1.6-2.8-2.8l.9-.8-.8-1.9h-.7z"/></svg>',
    ig: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r=".9" fill="currentColor" stroke="none"/></svg>'
  };
  function toast(msg) {
    var t = document.querySelector('.vb-toast');
    if (!t) { t = document.createElement('div'); t.className = 'vb-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  }
  function share() {
    document.querySelectorAll('.social-sharing').forEach(function (box) {
      if (box.dataset.vbShare) return;
      box.dataset.vbShare = '1';
      var url = location.origin + location.pathname;
      var title = (document.querySelector('.product__title') || {}).textContent || document.title;
      title = title.trim();
      var pin = box.querySelector('a[href*="pinterest"]');
      box.querySelectorAll('a.social-sharing__link').forEach(function (a) { if (a !== pin) a.remove(); });
      var wa = document.createElement('a');
      wa.className = 'vb-share'; wa.target = '_blank'; wa.rel = 'noopener'; wa.title = 'WhatsApp';
      wa.href = 'https://wa.me/?text=' + encodeURIComponent(title + ' ' + url);
      wa.innerHTML = IC.wa;
      var ig = document.createElement('button');
      ig.type = 'button'; ig.className = 'vb-share'; ig.title = 'Instagram'; ig.innerHTML = IC.ig;
      ig.addEventListener('click', function () {
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        var done = function () { toast('Enlace copiado. Pégalo en tu historia o DM de Instagram.'); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
      });
      var label = box.querySelector('.form__label');
      var ref = label ? label.nextSibling : box.firstChild;
      box.insertBefore(wa, ref);
      if (pin) { pin.classList.add('vb-share'); box.insertBefore(pin, wa.nextSibling); }
      box.appendChild(ig);
    });
  }

  /* 7 - barra de progreso del envio gratis */
  var FREE = 35;
  function freeBar() {
    var f = document.getElementById('free');
    if (!f) return;
    var tr = f.querySelector('.vb-fs-track');
    if (!tr) { tr = document.createElement('div'); tr.className = 'vb-fs-track'; tr.innerHTML = '<div class="vb-fs-fill"></div>'; f.appendChild(tr); }
    var msg = f.querySelector('.freeShippingMessage');
    var ok = msg && !msg.classList.contains('hidden') && getComputedStyle(msg).display !== 'none';
    var pct = 100;
    if (!ok) {
      var m = f.querySelector('#free_money');
      var mm = m ? m.textContent.match(/\d+(?:[.,]\d+)?/) : null;
      var n = mm ? parseFloat(mm[0].replace(',', '.')) : NaN;
      pct = isNaN(n) ? 0 : Math.max(4, Math.min(100, (FREE - n) / FREE * 100));
    }
    var fill = tr.firstChild, w = pct.toFixed(0) + '%';
    if (fill.style.width !== w) fill.style.width = w;
  }

  /* 2 - galeria estilo ASOS en desktop: miniaturas a la izquierda, foto grande con flechas y zoom en el mismo recuadro */
  function sized(u, w) { return u.replace(/([?&])width=\d+/, '$1width=' + w) + (/[?&]width=/.test(u) ? '' : (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w); }
  function gallery() {
    if (window.innerWidth < 750) return;
    var wrap = document.querySelector('.product__media-wrapper');
    var list = wrap && wrap.querySelector('.product__media-list');
    if (!list || wrap.querySelector('.vb-gal')) return;
    var items = [].slice.call(list.children).map(function (li) {
      var a = li.querySelector('a[data-pswp-width]'), img = li.querySelector('img');
      return a && img ? { big: a.getAttribute('href'), alt: img.getAttribute('alt') || '' } : null;
    }).filter(Boolean);
    if (!items.length) return;
    var holder = list.closest('slider-component') || list;
    var g = document.createElement('div');
    g.className = 'vb-gal';
    var thumbs = items.map(function (it, i) {
      return '<button type="button" class="vb-gal__t" data-i="' + i + '" aria-label="Foto ' + (i + 1) + '"><img src="' + sized(it.big, 160) + '" alt="" loading="lazy"></button>';
    }).join('');
    var arrow = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    g.innerHTML = '<div class="vb-gal__thumbs">' + thumbs + '</div><div class="vb-gal__stage"><img class="vb-gal__img" alt=""><button type="button" class="vb-gal__nav vb-gal__nav--prev" aria-label="Foto anterior">' + arrow('M15 5l-7 7 7 7') + '</button><button type="button" class="vb-gal__nav vb-gal__nav--next" aria-label="Foto siguiente">' + arrow('M9 5l7 7-7 7') + '</button></div>';
    holder.parentElement.insertBefore(g, holder);
    holder.classList.add('vb-gal-hide');
    wrap.classList.add('vb-gal-on');
    var stage = g.querySelector('.vb-gal__stage'), img = g.querySelector('.vb-gal__img'), cur = 0, hi = false;
    var tEls = g.querySelectorAll('.vb-gal__t');
    function show(i) {
      cur = (i + items.length) % items.length;
      hi = false;
      stage.classList.remove('is-zoom');
      img.src = sized(items[cur].big, 1100);
      img.alt = items[cur].alt;
      tEls.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
      var on = tEls[cur], box = g.querySelector('.vb-gal__thumbs');
      if (on && box) { var top = on.offsetTop - box.offsetTop; if (top < box.scrollTop || top + on.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTop = top - 10; }
    }
    tEls.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
    g.querySelector('.vb-gal__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
    g.querySelector('.vb-gal__nav--next').addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
    function origin(e) {
      var r = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    }
    stage.addEventListener('click', function (e) {
      if (e.target.closest('.vb-gal__nav')) return;
      var z = !stage.classList.contains('is-zoom');
      if (z) { origin(e); if (!hi) { hi = true; img.src = sized(items[cur].big, 2200); } }
      stage.classList.toggle('is-zoom', z);
    });
    stage.addEventListener('mousemove', function (e) { if (stage.classList.contains('is-zoom')) origin(e); });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
    document.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowLeft') show(cur - 1); else if (e.key === 'ArrowRight') show(cur + 1);
    });
    show(0);
  }

  function run() { breadcrumb(); categorias(); verTodo(); buscar(); firstPhoto(); bs(); recos(); trust(); stickyBar(); headerVar(); moveDesc(); share(); freeBar(); gallery(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 400);
  setTimeout(run, 1500);
  window.addEventListener('resize', headerVar);
  new MutationObserver(function () { verTodo(); buscar(); bs(); recos(); freeBar(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
